/* eslint-disable import/prefer-default-export */
export const DEFAULT_CURRENT_PAGE = 1;
export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_PAGE_SIZE_SEARCH = 20;
export const DEFAULT_PAGE_SIZE_SKILLS = 10;
